import { ReactElement } from 'react';
import { KeyboardBackspaceRounded } from '@mui/icons-material';
import Grid from '@mui/material/Grid';

// Components
import { Button } from 'components/Button';

// Styles
import styles from '../Wizard.module.scss';

// Core + Store
import { ButtonVariant } from 'core';

// Types
import { IWizardProps } from '../types';

export const WizardButtonRow = (props: IWizardProps): ReactElement => {
  const { back, next, skip } = props;

  return (
    <Grid container sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 3 }}>
      <Grid>
        {back && (
          <Button className={styles['wizard-button']} variant={ButtonVariant.Tertiary} onClick={back}>
            <KeyboardBackspaceRounded /> Back
          </Button>
        )}
      </Grid>
      <Grid>
        <Grid container spacing={2} sx={{ justifyContent: 'flex-end' }}>
          <Grid>
            {skip && (
              <Button className={styles['wizard-button']} variant={ButtonVariant.Secondary} onClick={skip}>
                Skip
              </Button>
            )}
          </Grid>
          <Grid>
            {next && (
              <Button className={styles['wizard-button']} variant={ButtonVariant.Primary} onClick={next}>
                Next
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
